import { Component, ErrorInfo, ReactNode } from 'react'
import { Button } from './Button'
import { Card } from './Card'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <Card className="max-w-md mx-auto mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Ein Fehler ist aufgetreten
          </h2>
          <p className="text-gray-600 mb-4">
            Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support.
          </p>
          <Button onClick={() => window.location.reload()}>
            Seite neu laden
          </Button>
        </Card>
      )
    }

    return this.props.children
  }
}
